import React, {useContext,useState,useEffect} from 'react';
import {MyContext} from '../../login/MyContext';
//import {Link} from 'react-router-dom';
import Login from '../../login/Login';
import axios from 'axios';

//crear cuenta
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

import Count from '../principal/Count';

function Pagos () {

  const baseUrlAd="https://manager-ads.com/ApiAliraweb.com/tarjetas/tarjetas.php"
  const baseUrlAd2="https://manager-ads.com/ApiAliraweb.com/banco/banco.php"
  const baseUrlAd3="https://manager-ads.com/ApiAliraweb.com/nequi/nequi.php"
  const [data, setData]=useState([]);
 
    const {user} = useContext(MyContext); 
    
    //crear cuenta
    const [modalInsertar, setModalInsertar]=useState(false);
    const [modalInsertar2, setModalInsertar2]=useState(false);
    const [modalInsertar3, setModalInsertar3]=useState(false);
    const [modalEliminar, setModalEliminar]=useState(false);
   
   //Agregar cuenta
   const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const abrirCerrarModalInsertar2=()=>{
    setModalInsertar2(!modalInsertar2);
  }

  const abrirCerrarModalInsertar3=()=>{
    setModalInsertar3(!modalInsertar3);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }


  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id:'',
    cargo:''   
  });


  //Agregar registro banco

  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }


  //Agregrar registro
  const peticionPost = async() =>{
    var f = new FormData();
    f.append("names", user.name);
    f.append("tarjeta", frameworkSeleccionado.tarjeta);
    f.append("METHOD", "POST");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })

  }


    //Agregrar registro
    const peticionPost2 = async() =>{
      var f = new FormData();
      f.append("names", user.name);
      f.append("banco", frameworkSeleccionado.banco);
      f.append("t_cuenta", frameworkSeleccionado.t_cuenta);
      f.append("n_cuenta", frameworkSeleccionado.n_cuenta);
      f.append("METHOD", "POST");
      await axios.post(baseUrlAd2,f)
      .then(response=>{
       setData(data.concat(response.data));
       abrirCerrarModalInsertar2();
       abrirCerrarModalEliminar();
      }).catch(error=>{
        console.log(error);
      })
  
    }



    const peticionPost3 = async() =>{
      var f = new FormData();
      f.append("names", user.name);
      f.append("e5_direccion", frameworkSeleccionado.e5_direccion);
      f.append("METHOD", "POST");
      await axios.post(baseUrlAd3,f)
      .then(response=>{
       setData(data.concat(response.data));
       abrirCerrarModalInsertar3();
       abrirCerrarModalEliminar();
      }).catch(error=>{
        console.log(error);
      })
  
    }
  


  


   
    const [saldo, setData_s]=useState([]);

    const peticionGet  =async() =>{
        await axios.get(`https://manager-ads.com/ApiAliraweb.com/empresas/count_empresas_suspendias.php?id=${global.id}`)
        .then(res=>{
         setData_s(res.data);
        }).catch(error=>{
          console.log(error);
        })
    
      }

    useEffect(()=>{
    

        const interval = setInterval(() => {
          
         peticionGet();
         
           
         }, 1000);
      
       return () => setInterval(interval);
      
       },[])

  
    
    if(user)
    {
  return (
 
<div id="content" class="app-content">

<ol class="breadcrumb float-xl-end">


</ol>





<Count/>



<div class="row">

<div class="col-xl-12">


<div class="panel panel-inverse" data-sortable-id="form-stuff-1" data-init="true">

<div class="panel-heading ui-sortable-handle">

<h4 class="panel-title">PAGOS</h4>
<div class="panel-heading-btn">
<a href="javascript:;" class="btn btn-xs btn-icon btn-default" data-toggle="panel-expand" title="Expandir"><i class="fa fa-expand"></i></a>

</div>
</div>


<div class="panel-body ">

<form>
 


<div class="note note-gray-500 mb-0" style={{background:'#34a8531c'}}>
<div class="note-content">
<h4><b>Sus ingresos</b></h4>
<p>
Se paga de forma mensual si el total es de al menos <b>USD 100.00</b> (su umbral de pago)

<br/>
Pagos en proceso <b>{user.e5_duracion}</b></p>

<div class="progress-bar bg-indigo progress-bar-striped progress-bar-animated rounded-pill fs-10px fw-bold" style={{width: '100%'}}>Umbral</div>
<p>Alcanzó <b>USD {saldo} </b> de <b>USD 100.00</b> su umbral de pago</p>

</div>
</div>

<br/>
<div class="note note-gray-500 mb-0" style={{background:'#34a8531c'}}>
<div class="note-content">
<h4><b>Pagos Internacionales </b> <i class="fas fa-comments-dollar"></i></h4> 
<p>
Transferencia Internacional a cuenta {user.tarjetas} <br/>
{user.name}
</p>

<button className="btn btn-success" onClick={()=>abrirCerrarModalInsertar()}> <i class="fab fa-google-pay"></i> Agregar cuenta internacional</button>
</div>
</div>

<br/>
<div class="note note-gray-500 mb-0" style={{background:'#34a8531c'}}>
<div class="note-content">
<h4><b>Pagos Colombia</b> <img src="assets/img/pais/colombia.png" width="15px" /></h4> 
<p>
Transferencia bancaria Colombia •••• ••• <br/>
Nequi <br/>
{user.name}
</p>

<button className="btn btn-success" onClick={()=>abrirCerrarModalInsertar2()}> <i class="fa fa-university"></i> Agregar Cuenta Bancaria</button> <br /><br />
<button  onClick={()=>abrirCerrarModalInsertar3()} style={{background:"none",border: "none" }}> <img src="assets/img/pais/nequi.png" width="80px" /></button>
</div>
</div>







<br/>





</form>
</div>





</div>

</div>




</div>



<Modal isOpen={modalInsertar}>
<ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fab fa-google-pay " style={{color:'yellow'}}></i> <font Size="2">CUENTA</font></ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

<div class="col-12">


<br/>
     <img  src="../assets/img/tarjetas/tarjetas.png" width="90px" /> <br/><br/>
     <input type="number" className="form-control"  name="tarjeta" onChange={handleChange}
      placeholder="4000001234567889" required /> 
      <br/>
       <input type="text" className="form-control" name="names"  onChange={handleChange}
     value={user.name} readOnly /> 
  </div>


  

  
  
 

  </div>

   
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost()}><i class="fab fa-google" style={{color:'yellow'}}></i> Agregar</button>{" "} 
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}><i class="fa-solid fa-circle-xmark"></i> Cancelar</button> 
 </ModalFooter>
</Modal>


<Modal isOpen={modalInsertar2}>
<ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fa fa-university " style={{color:'yellow'}}></i> <font Size="2">PAGOS COLOMBIA</font></ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

<div class="col-12">


<br/>
     <center><img  src="assets/img/pais/bank.png" width="50px" /></center> <br/>
  
     <select className="form-control"  name="banco" onChange={handleChange}>
      <option>Seelccione un banco </option>
      <option value="Bancolombia">Bancolombia </option>
      <option value="Davivienda">Davivienda</option>
      <option value="Banco de Bogotá">Banco de Bogotá</option>
      <option value="BBVA">BBVA</option>
      <option value="Banco de Occidente">Banco de Occidente</option>
      <option value="Scotiabank Colpatria">Scotiabank Colpatria</option>
      <option value="Banco Itaú">Banco Itaú</option>
      <option value="GNB Sudameris">GNB Sudameris</option>
      <option value="Banco Agrario">Banco Agrario</option>
      <option value="Banco Popular">Banco Popular</option>
      <option value="Banco Caja Social">Banco Caja Social</option>
      <option value="Banco AV Villas">Banco AV Villas</option>
      <option value="Banco Union">Banco Union</option>

      <option value="Bancoomeva">Bancoomeva</option>
      <option value="Banco Falabella">Banco Falabella</option>
      <option value="Banco Pichincha">Banco Pichincha</option>
      <option value="Banco W">Banco W</option>
      <option value="Banco Finandina">Banco Finandina</option>
      <option value="Bancamía">Bancamía</option>
      <option value="Banco Credifinanciera">Banco Credifinanciera</option>
      <option value="Bancoldex">Bancoldex</option>
     </select>
     <br/>
     <select className="form-control"  name="t_cuenta" onChange={handleChange}>
      <option>Tipo de cuenta</option>
      <option>Ahorros</option>
      <option>Corriente</option>
     </select>
     <br/>
     <input type="number" className="form-control"  name="n_cuenta" onChange={handleChange}
      placeholder="Número de cuenta" required /> 
      <br/>
       <input type="text" className="form-control" name="names"  onChange={handleChange}
     value={user.name} readOnly /> 
  </div>


  

  
  
 

  </div>

   
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost2()}><i class="fa fa-university" style={{color:'yellow'}}></i> Agregar</button>{" "} 
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar2()}><i class="fa-solid fa-circle-xmark"></i> Cancelar</button> 
 </ModalFooter>
</Modal>


<Modal isOpen={modalInsertar3}>
<ModalHeader  style={{backgroundColor:"#348fe2",color:"white"}} ><i class="fa fa-university " style={{color:'yellow'}}></i> <font Size="2">Nequi</font></ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

<div class="col-12">


<br/>
    <center> <img  src="assets/img/pais/nequi.svg" width="120px" /></center> <br/><br/>
     <input type="number" className="form-control"  name="e5_direccion" onChange={handleChange}
      placeholder="Cuenta" required /> 
      <br/>
       <input type="text" className="form-control" name="names"  onChange={handleChange}
     value={user.name} readOnly /> 
  </div>


  

  
  
 

  </div>

   
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost3()}><i class="fa fa-university" style={{color:'yellow'}}></i> Agregar</button>{" "} 
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar3()}><i class="fa-solid fa-circle-xmark"></i> Cancelar</button> 
 </ModalFooter>
</Modal>





<Modal isOpen={modalEliminar}>
 <ModalBody>
 <center> Cuenta asignada correctamente al usuario <b>{user.name}</b></center>
 <center><img src="../assets/img/logo/logo-admin.png" width="250px" /></center>
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-info w-100"
     onClick={()=>abrirCerrarModalEliminar()}
     >
       ACEPTAR
     </button>

   </ModalFooter>
 

</Modal>



</div>
   
  )
}

else if(!user){
    return"";
}

}

export default Pagos